// extracted by mini-css-extract-plugin
module.exports = {"mainContentHolder":"Main_mainContentHolder__R4Luk","bookingNameHolder":"Main_bookingNameHolder__2GxMi","sbLogo":"Main_sbLogo__2Ix0A"};